import React, { useState } from 'react';
import { motion } from 'framer-motion';
import GenelBilgi from '../components/detay/GenelBilgi';
import TeknikDetay from '../components/detay/TeknikDetay';
import LogoContainer from '../components/LogoContainer';
import Footer from '../components/Footer';
import { useParams } from 'react-router-dom';
import { DATA } from '../data/urunler-data'; 
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { imageVariants, textVariants, containerVariants, fadeInUp, azxc, bzxc } from '../script/animationVariants';
import LinkComponent from '../components/LinkComponent';
import MagnifyingGlassComponent from '../components/MagnifyingGlassComponent';
import { useTranslation } from 'react-i18next';

const Detay = () => {
    const { id1, id2, id3 } = useParams();
    const [toggle, setToggle] = useState(false);
    const [open, setOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const category = DATA.find(category => category.link === id1);
    const innerCategory = category.innerCategory.find(innerCategory => innerCategory.link === id2);
    const system = innerCategory.innerCategory.find(systems => systems.link === id3);

    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setOpen(true);
    };

    return (
        <div className='bg-white customHScreen pb-20 '>
        <LinkComponent />
        <div className='grid grid-cols-14'>
            <div className='col-start-2 col-span-12'>
                <motion.div
                    className='grid grid-cols-1 md:grid-cols-2 gap-10'
                    initial='hidden'
                    whileInView='visible'
                    exit='exit'
                    variants={containerVariants}
                >
                    <motion.div className='cursor-pointer' variants={imageVariants}>
                        <motion.div>
                            <div className='relative'>
                            <motion.img
                                className='aspect-video object-cover w-full'
                                src={`/images/systems/${id1}/${id2}/${id3}/1.png`}
                                alt={system?.name ? system.name[currentLanguage] : ''}
                            />
                                         <img 
                                        src='/images/filigran-rectangle.png' 
                                        className='absolute top-0 left-0 w-full h-full object-cover pointer-events-none' 
                                        alt=""
                                    />
                                    </div>
                            <motion.div className='w-full flex justify-between items-center font-thin text-16 pt-4 pb-6 relative'>
                                <div className='h-7 w-7 flex justify-center items-center relative pr-6'>
                                    <div className='h-px absolute w-full bg-customGray'></div>
                                    <div className='h-px absolute w-full bg-customGray rotate-90'></div>
                                </div>
                                <div className='h-px w-1/3 bg-customGray absolute bottom-0 left-0'></div>
                            </motion.div>
                        </motion.div>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            variants={azxc}
                            className='grid grid-cols-2 md:grid-cols-4 gap-2 relative'
                        >
                            {system?.images?.map((img, index) => (
                                <motion.div key={index} variants={bzxc} className='relative group' onClick={() => handleImageClick(index)}>
                                    <MagnifyingGlassComponent />
                                    <motion.img
                                        src={`/images/systems/${id1}/${id2}/${id3}/${img}.png`}
                                        className='w-full object-cover cursor-pointer h-20'
                                        alt={`System image ${index + 1}`}
                                    />
                                    <img 
                                        src='/images/filigran-rectangle.png' 
                                        className='absolute top-0 left-0 w-full h-full object-cover pointer-events-none' 
                                        alt=""
                                    />
                                </motion.div>
                            ))}
                        </motion.div>
                    </motion.div>
                    <motion.div
                        className='flex flex-col justify-between'
                        initial='hidden'
                        whileInView='visible'
                        exit='exit'
                        variants={containerVariants}
                    >
                        <div className='font-light'>
                            <motion.h1 
                                variants={fadeInUp(0.2)} 
                                initial="initial" 
                                whileInView="animate" 
                                className='text-45 mb-6'
                            >
                                {system?.name ? system.name[currentLanguage] : ''}
                            </motion.h1>
                            <motion.p 
                                variants={fadeInUp(0.4)} 
                                initial="initial" 
                                whileInView="animate" 
                                className='mb-5'
                            >
                                {system?.mainText[0][currentLanguage] ? system.mainText[0][currentLanguage] : ''}
                          
                            </motion.p>
                        </div>
                            {/* <motion.div className='flex items-center space-x-2 mt-10'>
                                <img src='/images/icons/catalog.svg' alt='Catalog' />
                                <p className='font-extralight text-16'>E-KATALOG</p>
                                <img src='/images/icons/download.svg' alt='Download' />
                            </motion.div> */}
                        </motion.div>
                    </motion.div>

                    {/* <div>
                        <div className='grid md:grid-cols-2'>
                            <div className='flex text-24 md:text-27 mb-7'>
                                <div
                                    onClick={() => setToggle(false)}
                                    className={` mr-2 md:mr-10 ${!toggle ? 'font-bold' : 'font-light'} cursor-pointer`}
                                >
                                    GENEL BİLGİ
                                </div>
                                <div
                                    onClick={() => setToggle(true)}
                                    className={`${toggle ? 'font-bold' : 'font-light'} cursor-pointer`}
                                >
                                    TEKNİK DETAY
                                </div>
                            </div>
                        </div>


                        <whileInViewPresence mode="wait">
                            <motion.div
                                key={toggle ? 'teknik' : 'genel'}
                                initial="hidden"
                                whileInView="visible"
                                exit="exit"
                                variants={containerVariants}
                            >
                                {toggle ? (
                                    <motion.div variants={textVariants}>
                                        <TeknikDetay system={system} id1={id1} id2={id2} id3={id3} />
                                    </motion.div>
                                ) : (
                                    <motion.div variants={textVariants}>
                                        <GenelBilgi system={system} id1={id1} id2={id2} id3={id3} />
                                    </motion.div>
                                )}
                            </motion.div>
                        </whileInViewPresence>
                    </div> */}

                    {/* <div>
                        <div className='text-27 font-light mt-10 mb-5'>BU SİSTEM KULLANILARAK YAPILAN PROJELER</div>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            exit="exit"
                            variants={containerVariants}
                            className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'
                        >
                            {system?.projects?.map((project, index) => (
                                <motion.div
                                    key={index}
                                    className='mb-5'
                                    variants={containerVariants}
                                >
                                    <motion.div className='aspect-square mb-5' variants={imageVariants}>
                                        <img
                                            src={`/images/systems/${id1}/${id2}/${id3}/projects/${project.image}.jpg`}
                                            className='w-full h-full object-cover'
                                            alt={project.name}
                                        />
                                    </motion.div>
                                    <motion.h2 className='text-21 font-thin' variants={textVariants}>
                                        {project.name}
                                    </motion.h2>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div> */}
                </div>
            </div>


            {system && system.images && (
                <Lightbox
                    open={open}
                    close={() => setOpen(false)}
                    slides={system.images.map(img => ({
                        src: `/images/systems/${id1}/${id2}/${id3}/${img}.png`,
                        alt: ""
                    }))}
                    index={currentImageIndex}
                    animation={{ fade: { duration: 1 } }}
                    styles={{
                        container: { backgroundColor: "rgba(0, 0, 0, .9)" },
                    }}
                    render={{
                        slide: ({ slide }) => (
                            <div className="relative w-full h-full flex items-center justify-center" style={{ padding: '40px 0' }}>
                                <div className="relative inline-block" style={{ maxWidth: '100vw', maxHeight: 'calc(100vh - 80px)' }}>
                                    <img 
                                        src={slide.src} 
                                        alt={slide.alt || ""} 
                                        className="block"
                                        style={{ maxWidth: '100vw', maxHeight: 'calc(100vh - 80px)', width: 'auto', height: 'auto' }}
                                    />
                                    <img 
                                        src="/images/filigran-square.png" 
                                        alt="" 
                                        className="absolute top-0 left-0 w-full h-full pointer-events-none"
                                        style={{ objectFit: 'contain' }}
                                    />
                                </div>
                            </div>
                        )
                    }}
                />
            )}
        </div>
    );
};

export default Detay;
